export default __webpack_public_path__ + "static/media/27.f5b78663.jpg";